// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"mY-z","tooltip":"nY-z","tooltipContent":"oY-z","orderStatusWrapper":"pY-z"};